import { makeStyles } from '@mui/styles';
import { ImageCdn } from '@openclassrooms/images-cdn';

import styles from './styles';

const useStyles = makeStyles(styles, {
  classNamePrefix: 'InsetPicturedContent',
});

export default function InsetPicturedContent({
  classes: customClasses = {},
  breakpoint = 'sm',
  pictureUrl = null,
  children = null,
  hasPictureOnRight = false,
  pictureElement = null,
  pictureHeight = null,
}) {
  const classes = useStyles({ classes: customClasses, breakpoint });

  return (
    <div className={`${classes.root} ${hasPictureOnRight ? classes.hasPictureOnRight : ''}`}>
      <div className={classes.pictureContainer}>
        {pictureElement || (
          <ImageCdn className={classes.picture} alt="" src={pictureUrl} height={pictureHeight} />
        )}
      </div>
      <div className={classes.content}>{children}</div>
    </div>
  );
}
